import appleIcon from "..//assets/res/apple_white.svg";
import androidIcon from "..//assets/res/android_white.svg";
import downloadIcon from "..//assets/res/download_icon.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GET_BASE_URL } from "../utils/Constants";

const VerticalListItem = ({ game, handleItemClick, isForSearch = false }) => {
  const { name, image_path, rate, isForAndroid, isForIos, download } = game;

  return (
    <div className="flex flex-col mt-4" onClick={() => handleItemClick(game)}>
      <div className=" flex flex-row mx-4 ">
        <div className="h-16 w-16 rounded-xl bg-gray-800 flex-none overflow-hidden">
          <div >
            <LazyLoadImage
              className="h-16 w-16 object-cover object-center"
              src={GET_BASE_URL() + "images/" + image_path}
              alt={name}
            />
          </div>
        </div>
        <div className="flex flex-col justify-center ml-2 ">
          <div className="text-white medium text-xl break-words flex-initial">
            {name}
          </div>
          <div className="flex flex-row text-gray-400 medium items-center">
            <div className="flex flex-row mt-1">
              {isForAndroid && (
                <img src={androidIcon} className="h-4 w-4 mr-2" />
              )}
              {isForIos && <img src={appleIcon} className="h-4 w-4" />}
            </div>
          </div>
          {download && (
            <div className="text-gray-500 text-xs medium mt-0.5">
              {download}K downloads
            </div>
          )}
        </div>
        <div className="grow h-full flex flex-row justify-end items-center my-auto">
          {isForSearch && (
            <div
              className="rounded-full bg-black semiBold  text-lg text-blue-500 px-6 pt-0.5 w-20 h-8 tracking-widest"
              onClick={() => handleItemClick(game)}
            >
              Get
            </div>
          )}
          {!isForSearch && (
            <div
              className="rounded-full bg-dark-blue semiBold  tracking-widest h-[48px] w-[48px]"
              onClick={() => handleItemClick(game)}
            >
              <img
                src={downloadIcon}
                className="h-[48px]  p-[10px] w-[48px] "
              />
            </div>
          )}
        </div>
      </div>
      <div className="h-[0.5px] bg-gray-700 ml-20 mr-4  mt-2"></div>
    </div>
  );
};

export default VerticalListItem;
